<template>
    <form>
        <fieldset class="form_fieldset row">
            <div class="input-group col-12">
                <AppInput :value="search_data"
                          :errors="errors"
                          id="search"
                          name="search"
                          field="search"
                          @change="updateProps({ search: $event })"
                          :is-input-group="true"/>
                <div class="input-group-append">
                    <button class="btn btn-secondary" type="submit" @click.prevent="submitSearch">
                        <AppIcon class="searchform__icon" modifier="nav-search"/>
                    </button>
                </div>
            </div>
        </fieldset>
    </form>
</template>

<script>
import { mapState } from 'vuex';
import AppIcon from './AppIcon';
import Errors from '../utils/errors';
import AppInput from './form/AppInput';
import NotificationService from '../services/notification.service';

export default {
  components: {
    AppIcon,
    AppInput,
  },
  data() {
    return {
      errors: new Errors(),
    };
  },
  computed: {
    ...mapState({
      search_data: state => state.products.search_data.search,
    }),
  },
  mounted() {
    this.$store.dispatch('products/clearProducts');
    this.$store.commit('products/pagination', { total: null });
  },
  methods: {
    updateProps(props) {
      this.$store.commit('products/searchProps', props);
    },
    submitSearch() {
      this.errors.clear();
      this.$store.dispatch('products/searchProducts')
        .then((res) => {
          if (res.total === 0) {
            NotificationService.success('No matches found');
          } else {
            NotificationService.success('Search successful');
          }
        })
        .catch(err => this.errors.set(err.response.data.errors));
    },
  },
};
</script>
